export const RELARION_OPTION = [
  "คู่สมรส",
  "บิดา",
  "มารดา",
  "บุตร",
  "ลุง",
  "ป้า",
  "น้า",
  "อา",
  "ปู่",
  "ย่า",
  "ตา",
  "ยาย",
  "หลาน",
  "ญาติพี่น้อง",
  "ผู้อาศัย",
  "อื่นๆ",
];

export const dism = {
  height: window.screen.height / 2,
  width: window.screen.width / 2,
};
export const nodeSize = {
  height: 120,
  width: 250,
};
